import { createStore } from 'vuex'
import alert from './modules/alert'
import landing from './modules/landing'
import components from './modules/components'
import activeElement from './modules/active-element'
import choosedElement from './modules/choosed-element'
import device from './modules/device'
import inspector from './modules/inspector'

//workflow
import user from './workflow/user'
import statistic from './workflow/statistic'
import send from './workflow/send'

const STORAGE_DATA_KEY = 'landing_data'
const STORAGE_SETTINGS_KEY = 'landing_settings'

const landingLocalStoragePlugin = (store) => {
  store.subscribe((mutation, state) => {
    if (mutation.type.startsWith('landing/')) {
      try {
        localStorage.setItem(STORAGE_DATA_KEY, JSON.stringify(state.landing.landing || []))
        localStorage.setItem(STORAGE_SETTINGS_KEY, JSON.stringify(state.landing.landing_settings || {}))
      } catch (e) {
        console.warn('Ошибка записи в localStorage:', e)
      }
    }
  })
}

export default createStore({
  modules: {
    device,
    landing,
    components,
    activeElement,
    choosedElement,
    alert,
    user,
    send,
    inspector,
    statistic
  },
  plugins: [landingLocalStoragePlugin]
})
